export default __webpack_public_path__ + "static/media/refresh-white.8a6fd361.svg";